<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-sm-12">
        <div class="row justify-content-center mb-4">
          <img src="https://vuejs.org/images/logo.png" width="20%" alt="" />
        </div>
        <div class="row justify-content-center">
          <h1>O que é?</h1>
        </div>

        <p class="lead">
          Vue (pronuncia-se view ou viu) é uma estrutura progressiva para
          construir interfaces de usuário. Ao contrário de outras estruturas
          monolíticas, o Vue foi projetado desde o início para ser adotado de
          forma incremental. A biblioteca central concentra-se apenas na camada
          de visualização e é fácil de selecionar e integrar com outras
          bibliotecas ou projetos existentes. Por outro lado, o Vue também é
          perfeitamente capaz de fornecer aplicativos sofisticados de página
          única quando usado em combinação com ferramentas modernas e
          bibliotecas de suporte.
        </p>
      </div>

      <div class="col-sm-12 mt-5">
        <div class="row justify-content-center">
          <h1>Por que utilizar?</h1>
        </div>
        <p class="lead">
          Além da simplicidade oferecida pelas templates, os componentes do
          Vue.js são declarados como um objeto de configuração (options), com
          isso é muito simples entender oque o componente esta fazendo.
        </p>
        <p class="lead">
          O Vue tem hoje uma das melhores curvas de aprendizagem dentre os
          frameworks disponíveis, isso o torna interessante tanto para os devs
          quanto para as empresas que desejam desenvolver aplicações
          rapidamente.
        </p>
      </div>

      <div class="col-sm-12 mt-5">
        <div class="row justify-content-center">
          <h1>Onde baixar?</h1>
        </div>
        <p class="lead">
          Você pode realizar o download do Vue no site oficial ->
          <a target="_blank" href="https://vuejs.org/">https://vuejs.org/</a>.
          Lá você também pode encontrar tutoriais de aplicações simples,
          integrações de componentes e muito mais.
        </p>
      </div>

      <div class="col-sm-12 mt-5">
        <div class="row justify-content-center mb-4">
          <h1>Recursos e Componentes</h1>
        </div>

        <div class="row justify-content-center mb-4">
          <h3>Vuex</h3>
        </div>
        <p class="lead">
          Vuex é um padrão de gerenciamento de estado para aplicativos Vue.js.
          Ele serve como um armazenamento centralizado para todos os componentes
          em um aplicativo, com regras que garantem que o estado só pode ser
          alterado de maneira previsível.
        </p>
        <div class="row justify-content-center mb-4">
          <img src="https://vuex.vuejs.org/flow.png" width="600px" alt="" />
        </div>
        <p class="lead">
          O site que você está usando agora utiliza tanto vuex quanto
          vue-router! ambos são importantes para simplificar o processo de
          gerenciamento de estado e rotas da aplicação
        </p>

        <div class="row justify-content-center mb-4">
          <h3>Vue-Router</h3>
        </div>
        <p class="lead">
          Vue Router é o plugin de rotas oficial para Vue.js. Ele se integra
          profundamente ao núcleo do Vue.js para tornar a criação de aplicativos
          de página única simples e rápida. Acompanhe o site oficial pelo link
          ->
          <a target="_blank" href="https://router.vuejs.org/"
            >https://router.vuejs.org/</a
          >
        </p>
      </div>
    </div>

    <div class="text-center mt-5">
      <base-button type="primary" class="my-4" @click="scrollTop"
        >Voltar ao topo</base-button
      >
    </div>
  </div>
</template>

<script>
import { scrollTop } from "@/global";

export default {
  name: "vue-article",
  methods: { scrollTop: scrollTop },
};
</script>

<style>
</style>